import { DeviceMetricsDataPoint, GpuMemory } from '@/types/device'

const MEMORY_METRIC_KEY = /^gpu_(\d+)_vram_(free|total)_mb$/

export const buildGpuMemoryMetricKeys = (gpuIndexes: number[]) =>
  gpuIndexes
    .flatMap((index) => [
      `gpu_${index}_vram_free_mb`,
      `gpu_${index}_vram_total_mb`
    ])
    .join(',')

export const parseGpuMemory = (
  metrics: Record<string, DeviceMetricsDataPoint[]>
): Record<number, GpuMemory> => {
  const memory: Record<number, GpuMemory> = {}

  Object.entries(metrics).forEach(([key, points]) => {
    const match = MEMORY_METRIC_KEY.exec(key)
    const value = parseFloat(points[0]?.value ?? '')

    if (!match || Number.isNaN(value)) {
      return
    }

    const index = Number(match[1])

    memory[index] = {
      ...memory[index],
      [match[2] === 'free' ? 'freeMb' : 'totalMb']: value
    }
  })

  return memory
}
